import { Col, Row, List, Typography } from "antd";
import * as React from "react";
import Link from "../../../core/ui/components/Link";
import Title from "antd/lib/typography/Title";
import { TCaseLawDocumentPresentationModel } from "../../../caseLawDocuments/presenter/model/CaseLawDocumentPresentationModel";

interface Props {
  style?: any;
  caseLawDocuments: TCaseLawDocumentPresentationModel[];
  showCaseLawDocumentDetails: any;
  translate: any;
}

interface State {}

export default class CaseLawDocsForOrgansationIndex extends React.Component<
  Props,
  State
> {
  render() {
    let { caseLawDocuments, showCaseLawDocumentDetails, translate } =
      this.props;

    return (
      <div>
        <Row className={"search-result"}>
          <Col xs={24} sm={24}>
            <Title level={4}>
              {translate("editors.organisation_indexes.modal_message")}
            </Title>
          </Col>
        </Row>
        <div style={{ cursor: "pointer" }} className={"card-list-item"}>
          <List
            size="small"
            locale={{
              emptyText: translate("data_grid.empty_text")
            }}
            dataSource={caseLawDocuments}
            renderItem={(item) => (
              <Link
                block
                type="text"
                onClick={() => showCaseLawDocumentDetails(item.id)}
                children={
                  <Col>
                    <Typography.Paragraph ellipsis={{ rows: 3 }} strong>
                      {item.summaryTranslation ?? item.summary}
                    </Typography.Paragraph>
                  </Col>
                }
              />
            )}
          />
        </div>
      </div>
    );
  }
}
